import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { SessionBootstrapService } from '../services/session-bootstrap.service';

/** Prevents rendering /login when an authenticated session should resume a workflow route. */
export const loginEntryGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const sessionBootstrap = inject(SessionBootstrapService);

  if (authService.getIsLogoutClicked()) {
    return true;
  }

  // Never redirect away from /login during bootstrap (avoids login <-> quote navigation loops).
  if (sessionBootstrap.isActive()) {
    return true;
  }

  if (!!authService.getToken() && authService.hasRestorableSession()) {
    return router.parseUrl(sessionBootstrap.resolveIntendedRoute());
  }

  return true;
};
